import { type FC, useCallback, useMemo } from 'react';
import { MiniGridRow, TextCell } from '@direct-frontend/components';
import { type OpenApiSchemaAddon } from '#shared/api/schema';
import { usePreviewWidget } from '#shared/lib/previewWidget';
import { format } from '#shared/lib/string';

type AddonRowProps = {
    addon: OpenApiSchemaAddon;
};

export const AddonRow: FC<AddonRowProps> = ({ addon }) => {
    const { setOpen: openPreview } = usePreviewWidget();
    const handleClick = useCallback(() => {
        openPreview(`addon/${addon.id}`);
    }, [addon.id, openPreview]);

    const caption = useMemo<string | undefined>(() => {
        if (!addon.is_price_enabled) {
            return undefined;
        }

        if (addon.final_price && addon.final_price !== addon.price) {
            return format(addon.final_price, 'price');
        }

        return format(addon.price, 'price');
    }, [addon]);

    return (
        <MiniGridRow id={addon.id} onClick={handleClick}>
            <TextCell width="full" title={addon.title} caption={caption} />
        </MiniGridRow>
    );
};
